<template>
    <div class="card mt-2 mb-2 ms-5 me-5">
        <!-- <h1>{{ $store.getters.getRawMatFamily }}</h1> -->
        <div class="card-body">
            <h4><strong>Especificaciones de la materia prima</strong></h4>
            <div class="table-responsive">
                <table class="mx-auto">
                    <tbody>
                        <tr>
                            <td class="lblform">
                                <strong>Presentación/ Norma /Acabado:</strong>
                            </td>
                            <td colspan="3">
                                <select id="sheetSpecification" class="form-select avilable-input" v-model="sheet"
                                    @change="getParameters(sheet)">
                                    <option selected>Opciones disponibles...</option>
                                    <option v-for="sheetAv in aviableSheets" :key="sheetAv.id" v-bind:value="sheetAv">
                                        {{ sheetAv }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="lblform"><strong>Unidad de espesor:</strong></td>
                            <td>
                                <select id="sheetScale" class="form-select avilable-input" v-model="scale"
                                    @change="getSheetId(scale)">
                                    <option selected>Opciones disponibles...</option>
                                    <option v-for="scale in scales" :key="scale.id" v-bind:value="scale.sheet_id">
                                        {{ scale.sheet_scale }}
                                    </option>
                                </select>
                            </td>
                            <td class="lblform"><strong>Espesor solicitado:</strong></td>
                            <td>
                                <select id="sheetThickness" class="form-select avilable-input" v-model="sheetTypeId"
                                    @change="getInfoSheetType(sheetTypeId)">
                                    <option selected>Opciones disponibles...</option>
                                    <option v-for="sheetType in sheetTypes" :key="sheetType.id" v-bind:value="sheetType.id">
                                        {{ sheetType.thickness }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="lblform">
                                <strong>Espesor comercial en <i>(mm)</i>:</strong>
                            </td>
                            <td class="inputForm">
                                <input type="number" readonly class="form-control" id="sheetCommercialMm"
                                    v-model="sheetCommercialMm" />
                            </td>
                            <td class="lblform">
                                <strong>Precio por kilo de materia prima <i>(Lámina)</i>:</strong>
                            </td>
                            <td class="inputForm">
                                <input type="number" readonly class="form-control" id="sheetKiloPrice"
                                    v-model="sheetKiloPrice" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h4><strong>
                    Formatos disponibles según las especificaciones seleccionadas previamente.
                </strong></h4>
            <div class="table-responsive">
                <table class="mx-auto">
                    <tbody>
                        <tr>
                            <td class="lblform">
                                <strong>Tamaños:</strong>
                            </td>
                            <td colspan="3">
                                <select id="sheetSpecification" class="form-select avilable-input" v-model="sheetDimension"
                                    @change="getDimensions(sheetDimension)">
                                    <option selected>Opciones disponibles...</option>
                                    <option v-for="sheetDimAv in aviableSheetDimensions" :key="sheetDimAv.id"
                                        v-bind:value="sheetDimAv.dimensions">
                                        {{ sheetDimAv.dimensions }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>Ancho total en centímetros:</th>
                            <td><input type="number" readonly class="form-control" id="widthCm" v-model="widthCm"></td>
                            <th>Longitud total en centímetros:</th>
                            <td><input type="number" readonly class="form-control" id="lengthCm" v-model="lengthCm"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        getLength: Number,
        getWidth: Number,
    },
    watch: {
        getLength(newVal) {
            if (newVal !== null) {
                this.calculateWeight();
            }
        },
        getWidth(newVal) {
            if (newVal !== null) {
                this.calculateWeight();
            }
        },
    },
    data() {
        return {
            //Se hace una búsqueda de los tramos completos de lámina que están disponibles 
            aviableSheets: [],
            //Select 1
            //Luego de seleccionar el tramo completo con los parámetros presentation y specification se realiza búsqueda en Sheets
            sheetPresentation: "",
            sheetSpecification: "",
            //En la variable sheetKiloPrice se almacena el valor del kilo según la primera lámina que coincida con los parámetros anteriores
            sheetKiloPrice: 0,
            //Select 2
            //Unidades de espesor disponibles spara la lamina seleccionada
            scales: [],
            sheetFinalId: 0,
            //Select 3
            sheetTypes: [],
            sheetTypeId: 0,
            //Información del tipo de lámina final seleccionada
            sheetType: [],
            //Variable según el tipo de lámina seleccionada
            sheetCommercialMm: "",
            //Variable de peso
            sheetWeight: 0,
            //Tramos completos 
            aviableSheetDimensions: [],
            widthCm: 0,
            lengthCm: 0,
        };
    },
    methods: {
        getParameters(option) {
            //console.log(option);
            if (option != "") {
                const parts = option.split(" / ");
                this.sheetPresentation = parts[0].trim();
                this.sheetSpecification = parts[1].trim();
                // console.log(this.sheetPresentation);
                // console.log(this.sheetSpecification);
            } else {
                alert("Por favor, sleccione una opcion válida");
            }
            this.searchSheetsByParameters();
        },
        async searchSheetsByParameters() {
            if (this.sheetPresentation === "" || this.sheetSpecification === "") {
                console.log("Materia prima no selecionada");
            } else {
                try {
                    let res = await axios.get(RUTA_SERVIDOR + "api/sheet/list", {
                        params: {
                            sheet_presentation: this.sheetPresentation,
                            sheet_specification: this.sheetSpecification,
                        },
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    });
                    //console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        this.sheetKiloPrice = res.data[0].priceId["value"];
                        this.$emit("sendKiloPrice", this.sheetKiloPrice);
                        //console.log(this.sheetKiloPrice);
                        //console.log(res.data);
                        const keyValueArray = res.data.map((sheet) => ({
                            sheet_id: sheet.id,
                            sheet_scale: sheet.scale,
                        }));
                        this.scales = Array.from(keyValueArray);

                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
            }
        },
        getSheetId(option) {
            this.sheetFinalId = option;
            this.searchSheetsTypes();
            // console.log(this.sheetFinalId);
        },
        async searchSheetsTypes() {
            if (this.sheetFinalId == 0) {
                console.log("Materia prima no selecionada");
            } else {
                try {
                    let res = await axios.get(RUTA_SERVIDOR + "api/sheet/type/list", {
                        params: {
                            sheet_main_id: this.sheetFinalId,
                        },
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    });
                    // console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        // console.log(res.data);
                        this.sheetTypes = res.data;
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
            }
        },
        async getInfoSheetType() {
            if (this.sheetTypeId == 0) {
                console.log("Materia prima no selecionada");
            } else {
                try {
                    let res = await axios.get(RUTA_SERVIDOR + "api/sheet/type/get", {
                        params: {
                            sheetType_id: this.sheetTypeId,
                        },
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    });
                    //console.log(res.data);
                    this.$emit("sendSheetTypeId", this.sheetTypeId);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        //console.log(res.data);
                        this.sheetType = res.data[0];
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
                this.sheetCommercialMm = this.sheetType.thicknessCommercialMm;
                this.$emit("sendPriceConstant", this.sheetType.constPrice);
                this.$emit("sendCommercialMm", this.sheetCommercialMm);
                this.getSheetDimensionsAviable();
            }
        },
        calculateWeight() {
            this.sheetWeight = (this.lengthCm / 100) * (this.widthCm / 100) * (this.sheetCommercialMm) * (this.sheetType.constWeight);
            // console.log(this.sheetWeight);
            if (!isNaN(this.sheetWeight)) {
                let roundWeight = this.roundWeight(this.sheetWeight);
                //console.log(roundWeight);
                this.$emit("sendWeight", roundWeight);
            } else {
                console.log("Sheet weight not fount or NaN");
            }
        },
        async getSheetDimensionsAviable() {
            if (this.sheetPresentation === "" || this.sheetSpecification === "") {
                console.log("Lamina no seleccionada");
            } else {
                try {
                    let res = await axios.get(RUTA_SERVIDOR + "api/sheet/dimension/list", {
                        params: {
                            presentation: this.sheetPresentation,
                            specification: this.sheetSpecification,
                        },
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    });
                    // console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        // console.log(res.data);
                        this.aviableSheetDimensions = res.data;
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
            }
        },
        getDimensions(option) {
            //console.log("Opcion:", option);
            if (option != "") {
                // Separar las dimensiones
                let singleDim = option.split("x");
                this.widthCm = parseFloat(singleDim[0].trim()) / 10;
                this.lengthCm = parseFloat(singleDim[1].replace("mm", "").trim()) / 10;
            } else {
                alert("Tamaño inválido, intente de nuevo.")
            }
            this.calculateWeight();
            this.$emit("sendDimensions", { width: this.widthCm, length: this.lengthCm });
        },
        roundWeight(numero) {
            return Math.round(numero * 10) / 10;
        },
    },
    beforeMount() {
        axios
            .get(RUTA_SERVIDOR + "api/sheet/dimension/list", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
            // .then((res) => (console.log(res.data)))
            .then((res) => {
                // Aquí colocas el código para eliminar los valores repetidos
                const uniqueSheets = new Set();
                res.data.forEach((aviableSheet) => {
                    // Reemplazar "/" por "-"
                    //const specificationText = aviableSheet.specification.replace(/\//g, "-");
                    const sheetText = `${aviableSheet.presentation} / ${aviableSheet.specification}`;
                    uniqueSheets.add(sheetText);
                });
                this.aviableSheets = Array.from(uniqueSheets);

                // Continúas con la asignación de los datos a la propiedad aviableSheets
                // this.aviableSheets = res.data;
            })
            .catch((err) => console.log(`There has been an error ${err}`));
    },
};
</script>
<style scoped>
.card {
    border: solid 2px #a6323b;
}

input [type="number"] {
    padding: 2px 6px 2px 16px;
    border: solid 5px #999999;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
}

.avilable-input {
    background-color: #FCE196;
}
</style>